<section class="form_section">
  <div class="dialog-header">
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h2>Crear minuta</h2>
  <form [formGroup]="form" class="form_register_minutes" (submit)="submit()">
    <mat-form-field>
      <mat-label>Línea Factoring</mat-label>
      <input matInput formControlName="factoringLine" mask="separator" thousandSeparator="." />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Línea Garantía</mat-label>
      <input matInput formControlName="warrantyLine" mask="separator" thousandSeparator="." />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Fecha de Expiración</mat-label>
      <input type="date" matInput formControlName="dueDate" />
    </mat-form-field>

    <mat-form-field class="example-form-field">
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="description"
        placeholder="Describe al cliente y operación a evaluar"></textarea>

    </mat-form-field>

    <section *ngIf="data.operations.length > 0">
      <h3>Op. Factoring</h3>
      <table mat-table [dataSource]="data.operations">
        <ng-container matColumnDef="folio">
          <th mat-header-cell *matHeaderCellDef class="th-title">
            Folio
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.folio }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="financedAmount">
          <th mat-header-cell *matHeaderCellDef class="th-title">
            Monto Financiamiento
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{ element.financedAmount | number : "3.0" }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="fechaCesion">
          <th mat-header-cell *matHeaderCellDef class="th-title">
            Fecha de Cesión
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.fechaCesion | date : "dd/MM/yyyy" }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="transferAmount">
          <th mat-header-cell *matHeaderCellDef class="th-title">
            Monto Transferencia
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.transferAmount | number }}</h6>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns">
      </table>
    </section>

    <section *ngIf="data.warranties">
      <h3>Garantías</h3>
      <div class="overflow-table">
        <table mat-table [dataSource]="data.warranties">
          <ng-container matColumnDef="warrantyType">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Tipoo
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.warrantyType }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="insuranceCompany">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Aseguradora
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.insuranceCompany }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Monto
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.amount | currency : 'CLP' }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="amountType">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Moneda
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.amountType }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="cost">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Comisión
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.cost | currency : 'CLP' }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="requestDate">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Desde
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.requestDate | date : 'dd-MM-yyyy' }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Hasta
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.endDate | date : 'dd-MM-yyyy' }}</h6>
            </td>
          </ng-container>
          <ng-container matColumnDef="insuranceBroker">
            <th mat-header-cell *matHeaderCellDef class="th-title">
              Corredor
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
              <h6>{{ element.insuranceBroker }}</h6>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="warrantyColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: warrantyColumns">
        </table>  
      </div>
    </section>

    <button type="submit" mat-stroked-button color="primary" class="w-50">Generar Minuta
    </button>
  </form>
</section>